import { analyticsConfig, sanitizeEventProps } from "./config"

const PLAUSIBLE_SCRIPT_ID = "almagesto-plausible-script"

const isBrowser = () =>
  typeof window !== "undefined" && typeof document !== "undefined"

const ensurePlausibleQueue = () => {
  window.plausible =
    window.plausible ||
    function plausible() {
      window.plausible.q = window.plausible.q || []
      window.plausible.q.push(arguments)
    }
}

export const initializePlausible = (config = analyticsConfig) => {
  if (!isBrowser() || !config.plausible.enabled) {
    return false
  }

  ensurePlausibleQueue()

  if (document.getElementById(PLAUSIBLE_SCRIPT_ID)) {
    return true
  }

  const script = document.createElement("script")
  script.id = PLAUSIBLE_SCRIPT_ID
  script.defer = true
  script.dataset.domain = config.plausible.domain
  script.src = config.plausible.scriptUrl
  document.head.appendChild(script)

  return true
}

export const trackPlausibleEvent = (
  eventName,
  props = {},
  config = analyticsConfig
) => {
  if (!isBrowser() || !config.plausible.enabled) {
    return false
  }

  initializePlausible(config)
  window.plausible(eventName, { props: sanitizeEventProps(props) })

  return true
}
